const API_URL = `${process.env.BASE_API_URL}`;

export const GET_CONTRACT_PROJECTS = projectId => `${API_URL}/project/${projectId}`;
export const GET_TASK = taskId => `${API_URL}/project-tasks/${taskId}`;

export const GET_PLACE = coords => `https://geocode-maps.yandex.ru/1.x/?format=json&apikey=1f753f8a-5d52-44a2-89a3-ca810233a2ba&geocode=${coords[1]}%2C${coords[0]}`
